/* eslint-disable @typescript-eslint/no-explicit-any */
import { HijriParser, isNullOrUndefined } from '@syncfusion/ej2-base';
/** @private */
export class Gregorian {
    firstDateOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth());
    }
    lastDateOfMonth(dt) {
        return new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
    }
    isMonthStart(date) {
        return (date.getDate() === 1);
    }
    getLeapYearDaysCount() {
        return 366;
    }
    getYearDaysCount(date, interval) {
        return ((date.getFullYear() + interval) % 4 === 0) ? 366 : 365;
    }
    getDate(date) {
        return date.getDate();
    }
    getMonth(date) {
        return (date.getMonth() + 1);
    }
    getFullYear(date) {
        return date.getFullYear();
    }
    getYearLastDate(date, interval) {
        return new Date(date.getFullYear() + interval, 0, 0);
    }
    getMonthDaysCount(date) {
        return this.lastDateOfMonth(date).getDate();
    }
    getMonthStartDate(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes());
    }
    getMonthEndDate(date) {
        date.setDate(1);
        return new Date(date.setMonth(date.getMonth() + 1));
    }
    getExpectedDays(date, days) {
        return days;
    }
    setDate(dateObj, date) {
        dateObj.setDate(date);
    }
    setValidDate(date, interval, startDate, monthValue, beginDate) {
        if (!isNullOrUndefined(beginDate)) {
            date.setMonth((beginDate ? monthValue : date.getMonth()) + interval);
        }
        else {
            date.setMonth(date.getMonth() + interval, startDate);
        }
    }
    setMonth(date, interval, startDate) {
        date.setDate(1);
        date.setFullYear(date.getFullYear());
        date.setMonth(interval - 1);
        const maxDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        date.setDate(Math.min(startDate, maxDay));
    }
    addYears(date, interval) {
        date.setFullYear(date.getFullYear() + interval);
    }
    isSameMonth(date1, date2) {
        return (date1.getMonth() === date2.getMonth());
    }
    checkMonth(date, months) {
        return (months.indexOf(date.getMonth() + 1) === -1);
    }
    compareMonth(date1, date2) {
        return (date1.getMonth() > date2.getMonth());
    }
    isSameYear(date1, date2) {
        return (date1.getFullYear() === date2.getFullYear());
    }
    isLastMonth(date) {
        return (date.getMonth() === 11);
    }
    isLeapYear(year, interval) {
        return ((year + interval) % 4 === 0);
    }
}
/** @private */
export class Islamic {
    firstDateOfMonth(date) {
        const hDate = this.getHijriDate(date);
        const gDate = HijriParser.toGregorian(hDate.year, hDate.month, 1);
        return gDate;
    }
    lastDateOfMonth(date) {
        const hDate = this.getHijriDate(date);
        const daysInMonth = this.getDaysInMonth(hDate.month, hDate.year);
        const gDate = HijriParser.toGregorian(hDate.year, hDate.month, daysInMonth);
        let finalGDate = new Date(gDate.getTime());
        finalGDate = new Date(finalGDate.setDate(finalGDate.getDate() + 1));
        let finalHDate = this.getHijriDate(finalGDate);
        if (hDate.month === finalHDate.month) {
            return finalGDate;
        }
        finalHDate = this.getHijriDate(gDate);
        if (hDate.month === finalHDate.month) {
            return gDate;
        }
        return new Date(gDate.setDate(gDate.getDate() - 1));
    }
    isMonthStart(date) {
        const hijriDate = this.getHijriDate(date);
        return (hijriDate.date === 1);
    }
    getLeapYearDaysCount() {
        return 355;
    }
    getYearDaysCount(date, interval) {
        const hDate = this.getHijriDate(date);
        return this.isLeapYear(hDate.year, interval) ? 355 : 354;
    }
    getDate(date) {
        const hijriDate = this.getHijriDate(date);
        return hijriDate.date;
    }
    getMonth(date) {
        const hDate = this.getHijriDate(date);
        return hDate.month;
    }
    getFullYear(date) {
        const hDate = this.getHijriDate(date);
        return hDate.year;
    }
    getYearLastDate(date, interval) {
        const hDate = this.getHijriDate(date);
        const gDate = HijriParser.toGregorian(hDate.year + interval, 1, 0);
        return gDate;
    }
    getMonthDaysCount(date) {
        const maxDate = this.lastDateOfMonth(date);
        const hijriDate = this.getHijriDate(maxDate);
        return hijriDate.date;
    }
    getMonthStartDate(date) {
        const firstDate = this.firstDateOfMonth(date);
        return new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate(), date.getHours(), date.getMinutes());
    }
    getMonthEndDate(date) {
        const lastDate = this.lastDateOfMonth(date);
        lastDate.setDate(lastDate.getDate() + 1);
        return new Date(lastDate.setMonth(lastDate.getMonth()));
    }
    getExpectedDays(date, days) {
        const hDate = this.getHijriDate(date);
        const day = [];
        for (let i = 0; i < days.length; i++) {
            const gDate = HijriParser.toGregorian(hDate.year, hDate.month, days[parseInt(i.toString(), 10)]);
            day.push(gDate.getDate());
        }
        return day;
    }
    setDate(dateObj, date) {
        const hDate = this.getHijriDate(dateObj);
        const gDate = HijriParser.toGregorian(hDate.year, hDate.month, date);
        this.updateDateObj(dateObj, gDate);
    }
    setValidDate(date, interval, startDate, monthValue, beginDate) {
        const firstDate = (!isNullOrUndefined(beginDate)) ? this.firstDateOfMonth(beginDate) : date;
        const hDate = this.getHijriDate(firstDate);
        const gDate = HijriParser.toGregorian(hDate.year, hDate.month + interval, startDate);
        this.updateDateObj(date, gDate);
    }
    setMonth(date, interval, startDate) {
        const hDate = this.getHijriDate(date);
        const gDate = HijriParser.toGregorian(hDate.year, interval, startDate);
        this.updateDateObj(date, gDate);
    }
    addYears(date, interval, monthValue) {
        const hDate = this.getHijriDate(date);
        const gDate = HijriParser.toGregorian(hDate.year + interval, monthValue, 1);
        this.updateDateObj(date, gDate);
    }
    isSameMonth(date1, date2) {
        const currentHijri = this.getHijriDate(date1);
        const tempHijri = this.getHijriDate(date2);
        return (currentHijri.month === tempHijri.month);
    }
    checkMonth(date, months) {
        const hDate = this.getHijriDate(date);
        return (months.indexOf(hDate.month) === -1);
    }
    compareMonth(date1, date2) {
        const hDate = this.getHijriDate(date1);
        const hDate1 = this.getHijriDate(date2);
        return (hDate.month > hDate1.month);
    }
    isSameYear(date1, date2) {
        const hDate = this.getHijriDate(date1);
        const hDate1 = this.getHijriDate(date2);
        return (hDate.year === hDate1.year);
    }
    isLastMonth(date) {
        const hDate = this.getHijriDate(date);
        return (hDate.month === 12);
    }
    updateDateObj(date, gDate) {
        date.setFullYear(gDate.getFullYear(), gDate.getMonth(), gDate.getDate());
    }
    isLeapYear(year, interval) {
        return (14 + 11 * (year + interval)) % 30 < 11;
    }
    getDaysInMonth(month, year) {
        let length = 0;
        length = 29 + ((month + 1) % 2);
        if (month === 11 && this.isLeapYear(year, 0)) {
            length++;
        }
        return length;
    }
    getHijriDate(date) {
        return HijriParser.getHijriDate(date);
    }
}
